import React, { useState, useEffect, useRef } from "react";
import { MdOutlineEnergySavingsLeaf, MdEmojiEvents } from "react-icons/md";
import { FaHandHoldingWater, FaSchool, FaDownload, FaPeopleCarry, FaFilter } from "react-icons/fa";
import { TbVaccineBottleOff } from "react-icons/tb";
import { IoFastFood, IoMan } from "react-icons/io5";
import { FaBoxesPacking, FaBox } from "react-icons/fa6";
import { GiTeacher } from "react-icons/gi";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axiosConn from "config/axiosConn";
import { Card, CardHeader, CardBody, CardFooter, CardTitle, Row, Col } from "reactstrap";
import { Container, Image, Button, Form, Table } from "react-bootstrap";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import Helper from "../../../helper/Common_Helper"
import ApexChartMonthWise from "./ApexChartMonthWise";
import ApexChartQuarterWise from "./ApexChartQuarterWise";
import healthy from "../../../assets/images/yoga.png";
import food from "../../../assets/images/sustainable_food_system.png";
import ewaste from "../../../assets/images/renewable.png";
import waste from "../../../assets/images/reduce_waste.png";
import energy from "../../../assets/images/energy-saving.png";
import water from "../../../assets/images/save-water.png";
import plastic from "../../../assets/images/no-plastic.png";
import { toast } from "react-toastify";
import CircleChart2 from "./pieChartLevel2.jsx";
import { FaAngleDown } from "react-icons/fa6";
import { FcCollaboration } from "react-icons/fc";
import DynamicCount from "../../../helper/AutoMation";

function LevelTwoDashboard() {
    const navigate = useNavigate();
    const location = useLocation();
    const dropdownRef = useRef(null);
    const [countData, setCountData] = useState({})
    const [districtWiseData, setDistrictWiseData] = useState({})
    const [filterDistrict, setFilterDistrict] = useState([]);
    const [filteredSchool, setFilteredSchool] = useState([]);
    const [stateID, setStateID] = useState('');
    const [selectYear, setYear] = useState('');
    const [themeWiseCount, setThemeWiseCount] = useState([]);
    const [schooCount, setSchooCount] = useState({})
    const [isFilterShow, setIsFilterShow] = useState(true);
    const [quarterWiseData, setQuarterWiseData] = useState([])
    const [monthWiseData, setMonthWiseData] = useState([])
    const [chartStatus, setChartStatus] = useState(1)
    const [timeFilter, setTimeFilter] = useState(false)
    const [quickNum, setQuickNum] = useState("")
    const urlState = localStorage.getItem("filterDataState");
    const [collaborationCount, setCollaborationCount] = useState(0)
    const [selectedDuration, setSelectedDuration] = useState("");
    const [themeWiseCountEvent, setThemeWiseCountEvent] = useState({
        lifestylesAdoptedCount: {},
        foodSystemsCount: {},
        eWasteReducedCount: {},
        wasteReducedCount: {},
        energySavedCount: {},
        waterSavedCount: {},
        plasticReducedCount: {},
    });
    const params = new URLSearchParams(location.search);
    let state = params.get('state') || urlState;
    state = state.trim();

    if (state === 'ANDAMAN') {
        state = 'ANDAMAN & NICOBAR ISLANDS';
    }
    const storedState = localStorage.getItem('filterDataState');

    const [filterData, setFilterData] = useState(location?.state?.data || {
        state: urlState || "",
        district: "",
        theme_name: "",
        sub_themes: "",
        school_name: "",
        implemnt_mode: "",
        event_type: "",
        fromDate: "",
        toDate: ""
    })

    console.log('filterdata theme ',filterData)
 
    useEffect(() => {
        if (filterData.state) {
            localStorage.setItem('filterDataState', filterData.state);
        }
    }, [filterData.state]);

    useEffect(() => {
        getCount(filterData);
    }, [filterData]);

    useEffect(() => {
        let StateId = StateList.find(obj => obj.state_name == filterData.state)?.state_id;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == StateId);
        setFilterDistrict(filterdistrictList);
    }, [])

    const handleSelectState = (data) => {
        setStateID(data);
        setFilteredSchool([])
        let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
        let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
        setFilterDistrict(filterdistrictList);
        setFilterData(prevData => ({ ...prevData, state: StateName, district: '', school_name: "" }));
        getSchoolList({ state_id: data })
    }

    const handleSelectDistrict = async (value) => {
        setFilteredSchool([])
        setFilterData(prevData => ({ ...prevData, district: value, school_name: "" }));
        let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
        getSchoolList({ state_id: stateID, district_id: districtid })
    }

    const handleSelectTheme = async (value) => {
        setFilterData(prevData => ({ ...prevData, theme_name: value, sub_themes: "" }));
    }

  const handleFilterChange = (field, value) => {
    if (field === "toDate") {
      setSelectedDuration(`${filterData.fromDate} to ${value}`);
      if (
        filterData?.fromDate &&
        new Date(filterData?.fromDate) > new Date(value)
      ) {
        toast.error("Start date cannot be greater than end date");
        return;
      }
    }
    setFilterData((prevData) => ({ ...prevData, [field]: value }));
    if (field === "fromDate" || field === "toDate") {
      setQuickNum("");
    }
  };

    const getSchoolList = async (data) => {
        try {
            let response = await axiosConn('post', 'get-school-filter', data)
            if (response.data.status === 'success') {
                setFilteredSchool(response.data.result)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getCount = async (data) => {
        // console.log("dataahhhhhhhhhhhhhh", data);
        try {
            const result = await fetch(`https://ecoclubs.education.gov.in/api/admin-dashboard-count-district-wise`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });
            const response = await result.json();

            // console.log("response", response);
            if (response.status === 'success') {
                const finalData = response.data.dataCount;
                // console.log("finalData-----------------", finalData);
                setSchooCount({ totalSchoolCount: response?.data?.schoolCount });
                setCountData(finalData);
                setDistrictWiseData(finalData.districtWiseCount);
                setThemeWiseCount(finalData.themeWiseCount);
                setQuarterWiseData(finalData.quarterWise);
                setMonthWiseData(finalData.monthWise);

                const collaborationCounts = response?.data.CollaborationCount.stateCount;
                const matchedState = collaborationCounts?.find(item => item.state === storedState);

                if (matchedState === undefined || matchedState === 0) {
                    setCollaborationCount(0);
                } else {
                    setCollaborationCount(matchedState?.collaborationCount);
                }
            }

        } catch (error) {
            console.log(error);
        }
    }

    //    const getCount = async (data) => {
    //     try {
    //         setMatchedStateCount(null);  
    
    //         const response = await fetch('https://ecoclubs.education.gov.in/api/admin-dashboard-count-district-wise', {
    //             method: 'POST',
    //             headers: {
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(data),
    //         });
    
    //         const result = await response.json();
    
    //         console.log('12345678900000000', result.data);
    
    //         if (result.status === 'success') {
    //             const finalData = result?.data?.dataCount;
    
    //             // Set school count and other data
    //             setSchooCount({ totalSchoolCount: result?.data?.schoolCount });
    //             setCountData(finalData);
    //             setDistrictWiseData(finalData.districtWiseCount);
    //             setThemeWiseCount(finalData.themeWiseCount);
    //             setQuarterWiseData(finalData.quarterWise);
    //             setMonthWiseData(finalData.monthWise);
    
    //             const collaborationCounts = result?.data?.CollaborationCount;
    //             const matchedState = collaborationCounts?.find(item => item.state === stateName);

    //             if (matchedState) {
    //                 setMatchedStateCount(matchedState.collaborationCount);
    //             } else {
    //                 console.log(`No match for state: ${stateName}`);
    //             }
    //         }
    //     } catch (error) {
    //         console.log(error);
    //     }
    // };

    const getCountEvents = async (data) => {
        try {
            // Add Delhi to the request payload
            const dataWithState = {
                ...data,
                state: state // Include state information here
            };
    
            // Make the POST request with the modified data
            const response = await axiosConn('post', 'admin-dashboard-count', dataWithState);
    
            console.log('Response Data: ', response.data);
    
            // Check if the response is successful
            if (response.data.status === 'success') {
                // Extract the collaboration count
                // const collaborationCount = response.data.data.dataCount.CollaborationCount || 0;
                // console.log('Collaboration Count: ', collaborationCount);
    
                // Extract counts for different categories
                const themeWiseCountEvent = {
                    lifestylesAdoptedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.lifestylesAdoptedCount.initiateEvent || 0,
                    },
                    foodSystemsCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.foodSystemsCount.initiateEvent || 0,
                    },
                    eWasteReducedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.eWasteReducedCount.initiateEvent || 0,
                    },
                    wasteReducedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.wasteReducedCount.initiateEvent || 0,
                    },
                    energySavedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.energySavedCount.initiateEvent || 0,
                    },
                    waterSavedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.waterSavedCount.initiateEvent || 0,
                    },
                    plasticReducedCount: {
                        totalEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.totalEvent || 0,
                        completedEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.completedEvent || 0,
                        ongoingEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.ongoingEvent || 0,
                        initiateEvent: response.data.data.dataCount.themeWisetotalEventCount.plasticReducedCount.initiateEvent || 0,
                    }
                };
    
                console.log('Theme Wise Count Events: ', themeWiseCountEvent);
    
                setThemeWiseCountEvent(themeWiseCountEvent); 
                // setCollaborationCount(collaborationCount);   
            }
        } catch (error) {
            console.log('Error:', error);
        }
    };

    useEffect(() => {
        getCountEvents();
    }, []);

    const handleClickFilter = (district, filter) => {
        let data = { ...filterData, district };
        data['district'] = district;

        if (filter) {
            if (filter.implemnt_mode) {
                data['implemnt_mode'] = filter.implemnt_mode;
            }
            if (filter.event_type) {
                data['event_type'] = filter.event_type;
            }
        }
        navigate("/admin/view-district", { state: { data: data } })
    }
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setTimeFilter(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const applyQuickSelect = (quickSelect) => {
        const today = new Date();
        let startDate = null;
        let endDate = new Date();
    
        const quickSelectRanges = {
            last3Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 3);
            },
            last7Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 7);
            },
            last15Days: () => {
                startDate = new Date(today);
                startDate.setDate(today.getDate() - 15);
            },
            lastMonth: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 1);
            },
            last3Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 3);
            },
            last6Months: () => {
                startDate = new Date(today);
                startDate.setMonth(today.getMonth() - 6);
            },
            currentYear: () => {
                startDate = new Date(today.getFullYear(), 0, 1);
            },
            previousYear: () => {
                startDate = new Date(today.getFullYear() - 1, 0, 1);
                endDate = new Date(today.getFullYear() - 1, 11, 31);
            },
        };
    
        if (quickSelectRanges[quickSelect]) {
            quickSelectRanges[quickSelect]();
        } else {
            return;
        }

        setSelectedDuration(
            `${startDate.toISOString().split("T")[0]} to ${
              endDate.toISOString().split("T")[0]
            }`
          );
    
        setFilterData(prevData => ({
            ...prevData,
            fromDate: startDate.toISOString().split('T')[0],
            toDate: endDate.toISOString().split('T')[0]
        }));
        setTimeFilter(false);
    };

const handleQuickSelect = (period) => {
    applyQuickSelect(period);
};
    // Function to calculate start and end dates of the selected year
    const calculateYearRange = (year) => {
        if (!year) return { start: '', end: Helper.currentOrPastDate() };

        const startDate = `${year}-01-01`;
        const endDate = `${year}-12-31`;

        return { start: startDate, end: endDate };
    };
    // Calculate the date range for the selected year
    const { start, end } = calculateYearRange(selectYear);

    const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

    return (
        <>
            <section className="scholdashbrdSec superAdminDashboardSec">
                <Container fluid>
                    <div className="dashbrdTopSrchDiv lavel mt-3 mb-1" style={{position:"relative", zIndex:999}}>
                        <h2>State/District <span className="hdngBrkr"> Level </span> SNAPSHOT</h2>
                        <div className="text-end" style={{ display: "flex", gap: 8, justifyContent: "flex-end", alignItems: "center", flexWrap: "wrap" }}>
                            <Button
                                onClick={() => navigate("/admin/state/themes-analysis")}
                                style={{
                                    background: "linear-gradient(135deg, #0d9488 0%, #2563eb 100%)",
                                    border: "none",
                                    color: "#fff",
                                    fontWeight: 600,
                                    padding: "8px 18px",
                                    borderRadius: 8,
                                    boxShadow: "0 4px 14px rgba(13,148,136,0.35)",
                                    fontSize: 14,
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 6,
                                }}
                            >
                                📊 View Themes Analysis Dashboard
                            </Button>
                            <Button onClick={() => setIsFilterShow(!isFilterShow)}><FaFilter size={20} color="#dddddd" /> Filter</Button>
                            <Button onClick={() => navigate("/admin")}><IoMdArrowRoundBack size={20} color="#dddddd" /> Back</Button>
                        </div>
                        {isFilterShow && (
                            <div className="filter my-4">
                                <div className="container-fluid">
                                    <div className="row gy-3">
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="state" disabled={true} className="form-control" value={StateList.find(list => list.state_name === filterData.state)?.state_id || ''} onChange={(e) => handleSelectState(e.target.value)}>
                                                    <option value="">All States/UTs/ABs</option>
                                                    {StateList.map((list, i) => (
                                                        <option key={i} value={list.state_id}>{list.state_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="district" className="form-control" value={filterData.district} onChange={(e) => { handleSelectDistrict(e.target.value) }}>
                                                    <option value="">All District</option>
                                                    {filterDistrict.map((list, i) => (
                                                        <option key={i} value={list.district_name}>{list.district_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="school_name" className="form-control" value={filterData.school_name} onChange={(e) => handleFilterChange('school_name', e.target.value)}>
                                                    <option value="">All School</option>
                                                    {filteredSchool && filteredSchool.map((school, i) => (
                                                        <option key={i} value={school.school_name}>{school.school_name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="theme_name" className="form-control" value={filterData.theme_name} onChange={(e) => { handleSelectTheme(e.target.value) }}>
                                                    <option value="">All Theme</option>
                                                    {ThemeBaseRouting.map((list, i) => (
                                                        <option value={list.value}>{list.lable}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="sub_themes" className="form-control" value={filterData.sub_themes} onChange={(e) => handleFilterChange('sub_themes', e.target.value)}>
                                                    <option value="">All Sub Theme</option>
                                                    {filterData.theme_name && subThemes[filterData.theme_name]?.map((list, i) => (
                                                        <option value={list.value}>{list.label}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="card-stats" ref={dropdownRef}>
                                                {selectedDuration && (
                                                <div
                                                    style={{
                                                    color: "red",
                                                    fontSize: "12px",
                                                    marginBottom: "5px",
                                                    textAlign: "left",
                                                    }}
                                                >
                                                    <strong>Selected Duration:</strong>{" "}
                                                    {selectedDuration}
                                                </div>
                                                )}
                                                <button
                                                className="buttongreen form-control"
                                                onClick={() => setTimeFilter(!timeFilter)}
                                                >
                                                Select Duration
                                                <FaAngleDown />
                                                </button>
                                                {timeFilter ? (
                                                    <div className="contentTime d-flex justify-content-between align-items-start flex-wrap">
                                                    <div className="leftArea">
                                                        <h5 className="text-center">
                                                        Absolute time range
                                                        </h5>
                                                        <hr />
                                                        <div className="card-stats">
                                                        <select
                                                        name="selectYear"
                                                        className="form-control"
                                                        value={selectYear}
                                                        onChange={(e) => {
                                                            setYear(e.target.value);
                                                            setFilterData({
                                                            fromDate: "",
                                                            toDate: "",
                                                            });
                                                        }}
                                                        >
                                                        <option value="">All Years</option>
                                                        <option value="2023">2023</option>
                                                        <option value="2024">2024</option>
                                                        <option value="2025">2025</option>
                                                        </select>
                                                        </div>
                        
                                                        <div className="srchBx _sr1 w-100">
                                                        <label style={{ marginTop: "10px" }} htmlFor="fromDate">
                                                            From Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="fromDate"
                                                            min={start || ""}
                                                            max={end || Helper.currentOrPastDate()}
                                                            className="form-control"
                                                            value={filterData.fromDate}
                                                            onChange={(e) =>
                                                            handleFilterChange("fromDate", e.target.value)
                                                            }
                                                            required={selectYear !== ""} 
                                                        />
                                                        </div>
                        
                                                        <div className="srchBx _sr1 w-100">
                                                        <label style={{ marginTop: "10px" }} htmlFor="toDate">
                                                            To Date
                                                        </label>
                                                        <input
                                                            type="date"
                                                            name="toDate"
                                                            min={filterData.fromDate || ""}
                                                            max={end || Helper.currentOrPastDate()}
                                                            className="form-control"
                                                            value={filterData.toDate}
                                                            onChange={(e) => {
                                                            handleFilterChange("toDate", e.target.value);
                                                            setTimeFilter(false);
                                                            }}
                                                            required={selectYear !== ""} 
                                                        />
                                                        </div>
                        
                                                    </div>
                                                    <div className="RightArea">
                                                        <h5 className="text-center">Quick Ranges</h5>
                                                        <hr />
                                                        <ul>
                                                        <li
                                                            className={quickNum === 1 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(1);
                                                            handleQuickSelect("last3Days");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 1}
                                                            readOnly
                                                            />{" "}
                                                            Last 3 Days
                                                        </li>
                                                        <li
                                                            className={quickNum === 2 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(2);
                                                            handleQuickSelect("last7Days");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 2}
                                                            readOnly
                                                            />{" "}
                                                            Last 7 Days
                                                        </li>
                                                        <li
                                                            className={quickNum === 3 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(3);
                                                            handleQuickSelect("last15Days");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 3}
                                                            readOnly
                                                            />{" "}
                                                            Last 15 Days
                                                        </li>
                                                        <li
                                                            className={quickNum === 4 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(4);
                                                            handleQuickSelect("lastMonth");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 4}
                                                            readOnly
                                                            />{" "}
                                                            Last Month
                                                        </li>
                                                        <li
                                                            className={quickNum === 5 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(5);
                                                            handleQuickSelect("last3Months");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 5}
                                                            readOnly
                                                            />{" "}
                                                            Last 3 Months
                                                        </li>
                                                        <li
                                                            className={quickNum === 6 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(6);
                                                            handleQuickSelect("last6Months");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 6}
                                                            readOnly
                                                            />{" "}
                                                            Last 6 Months
                                                        </li>
                                                        <li
                                                            className={quickNum === 7 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(7);
                                                            handleQuickSelect("currentYear");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 7}
                                                            readOnly
                                                            />{" "}
                                                            Current Year
                                                        </li>
                                                        <li
                                                            className={quickNum === 8 ? "active" : ""}
                                                            onClick={() => {
                                                            setQuickNum(8);
                                                            handleQuickSelect("previousYear");
                                                            }}
                                                        >
                                                            <input
                                                            type="radio"
                                                            name="check"
                                                            checked={quickNum === 8}
                                                            readOnly
                                                            />{" "}
                                                            Previous Year
                                                        </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div>
                                        
              

                                        {/* <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="event_type" className="form-control" value={filterData.event_type} onChange={(e) => handleFilterChange('event_type', e.target.value)}>
                                                    <option value="">All Type of Event</option>
                                                    <option value="Action">Action</option>
                                                    <option value="Awareness">Awareness</option>
                                                    <option value="Action & Awareness both">Action & Awareness both</option>
                                                </select>
                                            </div>
                                        </div> 
                                        <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                                            <div className="card-stats card">
                                                <select name="implemnt_mode" className="form-control" value={filterData.implemnt_mode} onChange={(e) => handleFilterChange('implemnt_mode', e.target.value)}>
                                                    <option value="">All Mode of Implementation</option>
                                                    <option value="Digital">Digital</option>
                                                    <option value="Physical">Physical</option>
                                                </select>
                                            </div>
                                        </div>*/}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="dashbrdTopSrchDivlavel mt-2 mb-0" style={{position:"relative", zIndex:0}}>
                        <div className="d-flex justify-content-center">
                            <div className="boxdiv boxdivOne">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of <span className="text-success w100">Events</span></p>
                                        <h2>{countData.totalCount}</h2>
                                    </div>
                                    <MdEmojiEvents size={80} color="#969640" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    {/* <div className="bgdanger w-50">
                                        <p>Completed</p>
                                        <h2>{countData.completedCount}</h2>
                                    </div> */}
                                    <div className="bgdanger w-50">
                                        <p>Completed</p>
                                        {/* <h2 onClick={() => navigate('/admin/view')}><Link><DynamicCount value={countData?.totalEventCount?.completedEvent || 0} /></Link></h2> */}
                                        <h2
                                        onClick={() => {
                                            const completedEventCount =
                                            countData?.completedCount || 0;
                                            if (completedEventCount > 0) {
                                            navigate("/admin/view-state-list");
                                            }
                                        }}
                                        >
                                        {" "}
                                        <Link>
                                            {" "}
                                            <DynamicCount
                                            value={
                                                countData?.completedCount || 0
                                            }
                                            />
                                        </Link>
                                        </h2>
                                    </div>
                                    {/* <div className="bgdanger w-50">
                                        <p>Ongoing</p>
                                        <h2>{countData.pendingCount}</h2>
                                    </div> */}

                                    <div className="bgdanger w-50">
                                        <p>Ongoing</p>
                                        <h2
                                        onClick={() => {
                                            const completedEventCount =
                                            countData.pendingCount || 0;
                                            if (completedEventCount > 0) {
                                            navigate("/admin/view");
                                            }
                                        }}
                                        >
                                        <DynamicCount
                                            value={countData.pendingCount || 0}
                                        />
                                        </h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivTwo">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of <span className="text-success w100">Schools</span></p>
                                        <h2>{schooCount.totalSchoolCount || 0}</h2>
                                    </div>
                                    <FaSchool size={80} color="#9c6829" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-50">
                                        <p>Event Hosts</p>
                                        <h2>{countData.usedSchoolCount || 0}</h2>
                                    </div>
                                    <div className="bgdanger w-50">
                                        <p>Yet to Host</p>
                                        <h2>{schooCount.totalSchoolCount - countData.usedSchoolCount || 0}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivThree">
                                <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Number of <span className="text-success w100">Participants</span></p>
                                        <h2 style={{ height: 42 }}></h2>
                                    </div>
                                    <FaPeopleCarry size={80} color="#9f4d9b" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div className="bgdanger w-100">
                                        <p></p>
                                        <h2>{countData.numberOfParticipants || 0}</h2>
                                    </div>
                                </div>
                            </div>
                            <div className="boxdiv boxdivFour">
                            <div className="d-flex justify-content-between p-3">
                                    <div >
                                        <p>Total Number of <span className="text-success w100">Collaboration</span></p>
                                        <h2 style={{ height: 42 }}></h2>
                                    </div>
                                    <FcCollaboration size={80} color="#839c30" />
                                </div>
                                <div className="d-flex justify-content-between bg-success bottomBox">
                                    <div
                                        className="bgdanger w-100"
                                        onClick={() => {
                                        if (collaborationCount > 0) {
                                        navigate("/admin/collaboration", {
                                            state: { state: storedState, category: "Collaborations" },
                                            });
                                        }
                                        }}
                                    >
                                        <p> </p>
                                        <h2>
                                        <DynamicCount value={collaborationCount || 0} />
                                        </h2>
                                    </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </Container>

                {/* <Container fluid>
                    <div className="dashbrdTopSrchDiv activityListNewDiv mt-4">
                        <h4>Number of Events (Theme wise)</h4>
                        <ul>
                            <li>
                                <a href="#">
                                    <span><Image src={healthy} /></span>
                                    Adopt Healthy Lifestyles
                                    <b className="actNum">{themeWiseCount.lifestylesAdoptedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={food} /></span>
                                    Adopt Sustainable Food Systems
                                    <b className="actNum">{themeWiseCount.foodSystemsCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={ewaste} /></span>
                                    Reduce E-Waste
                                    <b className="actNum">{themeWiseCount.eWasteReducedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={waste} /></span>
                                    Reduce Waste
                                    <b className="actNum">{themeWiseCount.wasteReducedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={energy} /></span>
                                    Save Energy
                                    <b className="actNum">{themeWiseCount.energySavedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={water} /></span>
                                    Save Water
                                    <b className="actNum">{themeWiseCount.waterSavedCount || 0}</b>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <span><Image src={plastic} /></span>
                                    Say No to Single Use Plastic
                                    <b className="actNum">{themeWiseCount.plasticReducedCount || 0}</b>
                                </a>
                            </li>
                        </ul>
                    </div>
                </Container> */}

<Container fluid>
    <div className="container-wrapper mt-4">
        <h4>Number of Events (Theme Wise)</h4>
        <ul className="theme-list">
        <li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D5F2E3' }}>
            <span className="theme-icon">
                <Image src={healthy} alt="Adopt Healthy Lifestyles" fluid />
            </span>
            <p>Adopt Healthy Lifestyles</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                    <tr>
                        <td 
                            onClick={() => {
                                const state = filterData.state;
                                const themeLabel = 'Adopt Healthy Lifestyles';
                                const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                                window.location.href = url;
                            }}>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.totalEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.completedEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.ongoingEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.lifestylesAdoptedCount.initiateEvent || 0}</b>
                        </td>
                    </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FEE2E2' }}>
            <span className="theme-icon">
                <Image src={food} alt="Adopt Sustainable Food Systems" fluid />
            </span>
            <p>Adopt Sustainable Food Systems</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Adopt sustainable food systems';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.foodSystemsCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.foodSystemsCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.foodSystemsCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.foodSystemsCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FFF3CD' }}>
            <span className="theme-icon">
                <Image src={ewaste} alt="Reduce E-Waste" fluid />
            </span>
            <p>Reduce E-Waste</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Reduce E-Waste';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.eWasteReducedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.eWasteReducedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.eWasteReducedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.eWasteReducedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D1E7DD' }}>
            <span className="theme-icon">
                <Image src={waste} alt="Reduce Waste" fluid />
            </span>
            <p>Reduce Waste</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                    <tr>
                        <td 
                            onClick={() => {
                                const state = filterData.state;
                                const themeLabel = 'Reduce Waste';
                                const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                                window.location.href = url;
                            }}>
                            <b>{themeWiseCountEvent.wasteReducedCount.totalEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.wasteReducedCount.completedEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.wasteReducedCount.ongoingEvent || 0}</b>
                        </td>
                        <td>
                            <b>{themeWiseCountEvent.wasteReducedCount.initiateEvent || 0}</b>
                        </td>
                    </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#E2E3E5' }}>
            <span className="theme-icon">
                <Image src={energy} alt="Save Energy" fluid />
            </span>
            <p>Save Energy</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Save Energy';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.energySavedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.energySavedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.energySavedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.energySavedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#D3F9D8' }}>
            <span className="theme-icon">
                <Image src={water} alt="Save Water" fluid />
            </span>
            <p>Save Water</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                 <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Save Water';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.waterSavedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.waterSavedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.waterSavedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.waterSavedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

<li>
    <a href="#">
        <div className="theme-icon-wrapper" style={{ background: '#FFE6E6' }}>
            <span className="theme-icon">
                <Image src={plastic} alt="Say No to Single Use Plastic" fluid />
            </span>
            <p>Say No to Single Use Plastic</p>
        </div>
        <Table hover striped className="w-100">
            <thead>
                <tr>
                    <th>Total</th>
                    <th>Completed</th>
                    <th>Ongoing</th>
                    <th>Initiated</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td 
                        onClick={() => {
                            const state = filterData.state;
                            const themeLabel = 'Say No to Single Use Plastic';
                            const url = `/admin/view-state?state=${encodeURIComponent(state)}&themeLabel=${encodeURIComponent(themeLabel)}`;
                            window.location.href = url;
                        }}>
                        <b>{themeWiseCountEvent.plasticReducedCount.totalEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.plasticReducedCount.completedEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.plasticReducedCount.ongoingEvent || 0}</b>
                    </td>
                    <td>
                        <b>{themeWiseCountEvent.plasticReducedCount.initiateEvent || 0}</b>
                    </td>
                </tr>
            </tbody>
        </Table>
    </a>
</li>

        </ul>
    </div>
</Container>

                <div className="schlDashbrdRgt">
                    <div className="superFullDashboardDiv mt-1">
                        <div className="row">
                            <div className="col-5 col-xs-12 mapindiadiv">
                                <div className="btmTableDivIn">
                                    <div className="tableTopDiv">
                                        <h4 className="bold-text">Number of Events (District wise:  { filterData?.state || ""})</h4>
                                        <div className="Download">
                                            <FaDownload size={20} color="black" onClick={() => Helper.exportTableToCSV('ECO Club District Wise.csv', 'District', districtWiseData)} />
                                        </div>
                                        <div className="table-responsive">
                                            <table rules="all" className="table">
                                                <thead className="text-primary">
                                                    <tr className="tblHdngOne">
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                        <th>&nbsp;</th>
                                                        <th colSpan={filterData.implemnt_mode ? 1 : 2}>Mode of Implementation </th>
                                                    </tr>
                                                    <tr>
                                                        <th>Districts</th>
                                                        <th>Total</th>
                                                        <th>Completed</th>
                                                        {filterData.implemnt_mode === "Digital" && (
                                                            <th>Digital</th>
                                                        )}
                                                        {filterData.implemnt_mode === "Physical" && (
                                                            <th>Physical</th>
                                                        )}
                                                        {!filterData.implemnt_mode && (
                                                            <>
                                                                <th>Digital</th>
                                                                <th>Physical</th>
                                                            </>
                                                        )}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {districtWiseData && Object.entries(districtWiseData).map(([district, counts]) => (
                                                        <tr key={district}>
                                                            <td onClick={() => handleClickFilter(district)}><Link>{district}</Link></td>
                                                            <td onClick={() => counts.totalCount !== 0 ? handleClickFilter(district) : ""}><Link>{counts.totalCount || 0}</Link></td>
                                                            <td onClick={() => counts.totalCount !== 0 ? handleClickFilter(district) : ""}><Link>{counts.totalCount || 0}</Link></td>
                                                            {filterData.implemnt_mode === "Digital" && (
                                                                <td onClick={() => counts.digitalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Digital' }) : ""}><Link>{counts.digitalCount || 0}</Link></td>
                                                            )}
                                                            {filterData.implemnt_mode === "Physical" && (
                                                                <td onClick={() => counts.physicalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Physical' }) : ""}><Link>{counts.physicalCount || 0}</Link></td>
                                                            )}
                                                            {!filterData.implemnt_mode && (
                                                                <>
                                                                    <td onClick={() => counts.digitalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Digital' }) : ""}><Link>{counts.digitalCount || 0}</Link></td>
                                                                    <td onClick={() => counts.physicalCount !== 0 ? handleClickFilter(district, { 'implemnt_mode': 'Physical' }) : ""}><Link>{counts.physicalCount || 0}</Link></td>
                                                                </>
                                                            )}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                        <tr>
                                                            <td colSpan={7} className="text-right">
                                                                Total Number of Records:{districtWiseData ? Object.keys(districtWiseData).length : 0}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-7 col-xs-12 fullBoxData">
                                <Row>
                                    <h4 className="mb-2 bold-text">Total Impact  (Theme wise)</h4>
                                    <Col lg="4" md="6" sm="6" className="boxOne _2">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <MdOutlineEnergySavingsLeaf />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Energy Saved (Total Energy Saved Conserved Watts)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    767
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    <Col lg="4" md="6" sm="6" className="boxOne _3">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaHandHoldingWater />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Water Saved (Water Saved Conserved Ltrs)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    209
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    <Col lg="4" md="6" sm="6" className="boxOne _4">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <TbVaccineBottleOff />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">amount of single use plastic collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    278
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _5">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <IoFastFood />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">Sustainable Food Systems Adopted (Total no. of points earned)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    160
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _6">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaBox />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">No. of compost pits established</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    1
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _7">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <IoMan />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">LiFEStyles Adopted (Total no of points earned)</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    230
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>

                                    <Col lg="4" md="6" sm="6" className="boxOne _8">
                                        <Card className="card-stats">
                                            <CardBody>
                                                <Row>
                                                    <Col md="3" xs="3">
                                                        <div className="icon-big text-center icon-warning">
                                                            <FaBoxesPacking />
                                                        </div>
                                                    </Col>
                                                    <Col md="9" xs="9">
                                                        <div className="numbers">
                                                            <p className="card-category">amount of E-Waste collected</p>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                            <CardFooter>
                                                <CardTitle tag="h3" className="text-center">
                                                    580
                                                </CardTitle>
                                            </CardFooter>
                                        </Card>
                                    </Col>
                                    
                                </Row>
                            </div>
                            <Col sm={12} md={6} lg={6} className="mt-3">
                                        <Card className="card p-4" style={{ marginTop: '-15px' }}>
                                            <CardHeader>
                                                <Row>
                                                    <Col md="12">
                                                        <div className="d-flex justify-content-center w-100 mt-2" >
                                                            <div className="d-flex justify-content-start mr-5" style={{ marginRight: '15px' }}>
                                                                <Form.Check name="status" value="1" style={{ marginRight: '5px' }} onClick={() => setChartStatus(1)} type="radio" defaultChecked ></Form.Check>
                                                                <Form.Label className="ml-2">Quarter Wise</Form.Label>
                                                            </div>
                                                            <div className="d-flex justify-content-start mr-5" style={{ marginRight: '15px' }}>
                                                                <Form.Check name="status" value="2" style={{ marginRight: '5px' }} onClick={() => setChartStatus(2)} type="radio" ></Form.Check>
                                                                <Form.Label className="ml-2">Month Wise</Form.Label>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardHeader>
                                            <CardBody>
                                                {chartStatus === 1 ? <ApexChartQuarterWise dynamicData={quarterWiseData} />
                                                    : <ApexChartMonthWise dynamicData={monthWiseData} />}
                                            </CardBody>
                                        </Card>
                                    </Col>

                            <Col xs={12} sm={12} md={12} lg={6}>
                                <div className="card p-4">
                                    <h5 className="bold-text">Count of Events (Age wise)</h5>
                                    <CircleChart2  data={filterData.state} state={filterData.state} district={filterData.district}/>
                                </div>
                            </Col>
                        </div>
                    </div>
                </div>
            </section >
        </>
    );
}

export default LevelTwoDashboard;
